<template>
  <div id="app">
    <div class="top" style="background-color: #fafafa">
      <div class="left">
        <img src="./assets/logo1.png" alt="" />
      </div>
      <div class="center">
        <ul class="ulcenter" v-show="checkFlag">
          <li>
            <!-- <a  v-for="(item, index) in list" :key="item.path" :class="{ actived: $store.state.active == index }" @click="change(index)" style="margin-right: 10px; cursor: pointer;" v-show="classnone">{{ item.name }}</a> -->
            <a v-for="(item, index) in list" :key="item.path" :class="{ actived: $store.state.active == index }"
              @click="change(index)" style="margin-right: 10px; cursor: pointer">{{ item.name }}</a>
            <!-- <div class="buttonnew" style="display: flex" v-show="buttonnew"><el-button type="text" style="color: black" @click="clickhome()">首页</el-button><el-button type="text" disabled>管理平台</el-button><el-button type="text" disabled>数据核对</el-button><el-button type="text" disabled>输出报告</el-button></div> -->
          </li>
        </ul>
      </div>
      <div class="right" style="display: flex">
        <div class="headerInfo">
          <el-dropdown trigger="click" v-if="shezhishow()">
            <img src="./assets/header-setting.png" class="el-dropdown-link" style="margin-right: 5px; outline: none" />
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item v-if="shezhishow1()" @click="xiaoshi1" style="color: #7f8aa2">数据管理</el-dropdown-item>
                <el-dropdown-item v-if="shezhishow1()" @click="xiaoshi('/targetManage')" style="color: #7f8aa2">指标查看</el-dropdown-item>
                <el-dropdown-item v-if="shezhishow2()" @click="xiaoshi('/users')" style="color: #7f8aa2">用户管理</el-dropdown-item>
                <el-dropdown-item v-if="shezhishow5()" @click="xiaoshi('/register')" style="color: #7f8aa2">注册管理</el-dropdown-item>
                <el-dropdown-item v-if="shezhishow3()" @click="xiaoshi('/permission')" style="color: #7f8aa2">权限管理</el-dropdown-item>
                <el-dropdown-item v-if="shezhishow4()" @click="xiaoshi('/news')" style="color: #7f8aa2">新闻管理</el-dropdown-item>
                <el-dropdown-item v-if="shezhishow4()" @click="xiaoshi('/publicFactor')" style="color: #7f8aa2">公共机构因子维护</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
          <img src="./assets/header-user.png" style="margin-right: 10px" v-show="false" />
        </div>
        <div class="timer">
          <span style="color: #787878">{{ dateFormat(newDate).slice(0, 11)
          }}{{ dateFormat(newDate).slice(11, 19) }}</span>
        </div>
        <!-- <div class="rightkuang">
          <div class="imgdiv" v-if="weatherimg === 'qing'">
            <img src="./assets/qing.png" class="rightimg" />
          </div>
          <div class="imgdiv" v-if="weatherimg === 'yin'">
            <img src="./assets/yin.png" class="rightimg" />
          </div>
          <div class="imgdiv" v-if="weatherimg === 'yun'">
            <img src="./assets/duoyun.png" class="rightimg" />
          </div>
          <div class="imgdiv" v-if="weatherimg === 'yu'">
            <img src="./assets/yu.png" class="rightimg" />
          </div>
          <div class="imgdiv" v-if="weatherimg === 'wu'">
            <img src="./assets/yu.png" class="rightimg" />
          </div>
          <div class="imgdiv" v-if="weatherimg === 'shachen'">
            <img src="./assets/yu.png" class="rightimg" />
          </div>
        </div>
        <div style="margin-top: 5px">
          <p class="rightcity" style="color: #323233; text-align: center">
            {{ city }}市
          </p>
          <span class="rightcity" style="color: #323233"
            >{{ weather }} &nbsp</span
          ><span v-if="lower" class="rightcity">{{ lower }}°C </span>
        </div> -->
      </div>
    </div>
    <div class="bottom" style="margin-top: 1.25rem">
      <router-view v-if="isShow" v-slot="{ Component }">
        <keep-alive>
          <component :is="Component" />
        </keep-alive>
      </router-view>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isShow: true,
      newDate: new Date(),
      weather: "",
      weatherimg: "",
      lower: "",
      win: "",
      city: "",
      list: [
        { path: "#/home", name: "首页" },
        { path: "#/manage", name: "管理平台" },
        { path: "#/verify", name: "数据核对" },
        { path: "#/report", name: "输出报告" },
        { path: "#/helper", name: "使用帮助" },
      ],
    };
  },
  computed: {
    shezhi() {
      return this.$store.getters.shezhi;
    },
    getpermission() {
     
      return this.$store.getters.getpermission;
    },
    token() {
      return this.$store.getters.token;
    },
    classnone() {
      return this.$store.getters.classnone;
    },
    buttonnew() {
      return this.$store.getters.buttonnew;
    },
    pdfshenhe() {
      return this.$store.getters.pdfshenhe;
    },
    checkFlag() {
      return this.$store.getters.checkFlag;
    },
  },
  provide() {
    return {
      reload: this.reload,
    };
  },
  beforeCreate() {
    document
      .querySelector("body")
      .setAttribute("style", "margin:0;background-color:#f2f4f6");
  },
  created() {
    // this.getWeather(); // 获取天气
    //解决vuex数据在页面刷新被重置的问题
    //在页面加载时读取sessionStorage里的状态信息
    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem("store"))
        )
      );
    }

    //在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("store", JSON.stringify(this.$store.state));
    });
  },
  // 挂载时间
  mounted() {
    let that = this;
    this.timer = setInterval(function () {
      that.newDate = new Date().toLocaleString();
    });
    window.addEventListener("beforeunload", (e) => this.beforeunloadHandler(e));
  },
  // Vue 3 生命周期钩子变更: beforeDestroy -> beforeUnmount
  beforeUnmount: function () {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    async xiaoshi(path) {
      this.$store.commit("addM");
      await this.$router.push(path);
    },
    shezhishow() {
      let arr = this.getpermission;
      let target = false;
      if (
        (this.shezhi &&
          arr.some((item) => {
            return item.id === 6;
          })) ||
        arr.some((item) => {
          return item.id === 7;
        }) ||
        arr.some((item) => {
          return item.id === 8;
        }) ||
        arr.some((item) => {
          return item.id === 11;
        }) ||
        arr.some((item) => {
          return item.id === 12;
        })
      ) {
        target = true;
      }
      return target;
    },
    shezhishow1() {
      let arr = this.getpermission;
      let target = false;
      if (
        arr.some((item) => {
          return item.id === 6;
        })
      ) {
        target = true;
      }
      return target;
    },
    shezhishow2() {
      let arr = this.getpermission;
      let target = false;
      if (
        arr.some((item) => {
          return item.id === 7;
        })
      ) {
        target = true;
      }
      return target;
    },
    shezhishow3() {
      let arr = this.getpermission;
      let target = false;
      if (
        arr.some((item) => {
          return item.id === 8;
        })
      ) {
        target = true;
      }
      return target;
    },
    shezhishow4() {
      let arr = this.getpermission;
      let target = false;
      if (
        arr.some((item) => {
          return item.id === 12;
        })
      ) {
        target = true;
      }
      return target;
    },
    shezhishow5() {
      let arr = this.getpermission;
      let target = false;
      if (
        arr.some((item) => {
          return item.id === 11;
        })
      ) {
        target = true;
      }
      return target;
    },
    async xiaoshi1() {
      this.$store.commit("addM");
      localStorage.setItem('dataVerify', 'true')
      await this.$router.push("/sjgl");
    },
    shuaxin() {
      this.$store.commit("flag2change", 1);
    },
    reload() {
      // 先隐藏
      this.isShow = false;

      // $nextTick() 将回调延迟到下次 DOM 更新循环之后执行
      this.$nextTick(() => {
        this.isShow = true;
      });
    },
    dateFormat() {
      var date = new Date();
      var year = date.getFullYear();
      var month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var hours =
        date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      var minutes =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      var seconds =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      let week = date.getDay(); // 星期
      let weekArr = [
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
      ];
      // 拼接 时间格式处理
      return (
        year +
        "/" +
        month +
        "/" +
        day +
        " " +
        hours +
        ":" +
        minutes +
        ":" +
        seconds +
        " " +
        weekArr[week]
      );
    },
    // getWeather() {
    //   this.$axios({
    //     methods: "get",
    //     url: "https://tianqiapi.com/free/day",
    //     headers: {},
    //     params: {
    //       appid: "68261499",
    //       appsecret: "IfTIll7V",
    //       city: null, // 城市名称,不要带市和区
    //       ip: localStorage.getItem("Ip"), // IP地址
    //       callback: 0, // jsonp方式
    //     },
    //   }).then((res) => {
    //     this.city = res.data.city;
    //     this.weather = res.data.wea;
    //     this.weatherimg = res.data.wea_img;
    //     this.lower = res.data.tem;
    //     this.win = res.data.win;
    //   });
    // },
    async change(index) {
      if (index === 0) {
        await this.$router.push("/home");
        this.$store.commit("add", index);
      }
      if (index === 1) {
        if (this.token !== "") {
          await this.$router.push("/gl");
          this.$store.commit("add", index);
        } else {
          this.$router.push("/apply");
          this.$store.commit("classnone", false);
          this.$store.commit("buttonnew", true);
        }
      }
      if (index === 2) {
        if (
          this.getpermission.some((item) => {
            return item.id === 4;
          })
        ) {
          localStorage.setItem('dataVerify', 'false')
          await this.$router.push("/verify");
          this.$store.commit("add", index);
          this.$store.commit("flagtotable", 1);
        } else {
          localStorage.setItem('dataVerify', 'false')
          this.$router.replace("/verify")
        };
      }
      if (index === 3) {
        if (
          this.getpermission.some((item) => {
            return item.id === 5;
          })
        ) {
          await this.$router.push("/report");
          this.$store.commit("add", index);
          this.$store.commit("flag2change", 1);
          // setTimeout(this.shuaxin, 500);
        } else this.$router.replace("/report");
        // this.$store.commit("flag2change", 1);
      } else {
        this.$store.commit("add", index);
      }
      if (index === 4) {
        await this.$router.push("/helper");
      }
    },
    async clickhome() {
      await this.$router.push("/home");
      this.$store.commit("add", 0);
      this.$store.commit("flag8change", 1);
      this.$store.commit("classnone", true);
      this.$store.commit("buttonnew", false);
    },
    beforeunloadHandler(e) {
      e = e || window.event;
      if (e) {
        // e.returnValue = '关闭提示'
        this.$router.push("/home");
      }
    },
    playVideo() {
    },
  },
};
</script>

<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

a {
  text-decoration: none;
}

li {
  list-style: none;
}

.top {
  height: 3.2rem;
  margin-bottom: -10px;
  display: flex;
  box-shadow: 0 0.125rem 0.75rem 0 rgb(0 0 0 / 35%);
}

.left {
  flex: 1;
}

.left img {
  height: 2.5rem;
  margin-top: 0.5rem;
  margin-left: 0.2rem;
}

.center {
  // flex: 1;
  display: flex;
}

.center ul {
  height: 3.75rem;
}

.center li {
  float: left;
  height: 3.75rem;
  line-height: 3.75rem;
  text-align: center;
  margin-right: 1.25rem;
}

.center li a {
  padding: 0 0.125rem 0.125rem;
  color: #7f8aa2;
}

// .center li a:hover{
//   border-bottom: 1px solid #249ffc;
//   color: #249ffc;
// }
.right {
  flex: 1;
  font-size: 1.25rem;
  margin-right: 5px;
  justify-content: flex-end;
}

.right i {
  display: inline-block;
  width: 2.1875rem;
  margin-top: 1.25rem;
  // float: left;
}

.headerInfo {
  margin-right: 10px;
}

.right .headerInfo img {
  // all: initial;
  width: 30px;
  height: 30px;
  // float: left;
  margin-top: 10px;
}

.right .timer {
  float: left;
  margin-right: 10px;
  // border-right: 2px solid #787878;
  width: 70px;
}

.right .timer span {
  font-size: 0.75rem;
}

.actived {
  border-bottom: 1px solid #249ffc !important;
  color: #249ffc !important;
}

.el-dropdown-link {
  cursor: pointer;
}

.el-dropdown-menu__item {
  width: 120px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  padding: 0;
}

.el-dropdown-menu__item a {
  display: inline-block;
  width: 120px;
  height: 40px;
  text-align: center;
  line-height: 40px;
}

.el-dropdown-menu {
  padding: 0;
}

.rightkuang {
  height: 40px;
  border-left: 1px solid #787878;
  margin-top: 5px;
  margin-right: 10px;
}

.rightimg {
  width: 35px;
  margin-top: 2px;
}

.rightcity {
  font-size: 14px;
}

.ulcenter {
  margin-left: 100px;
}

.imgdiv {
  margin-left: 6px;
  margin-bottom: 5px;
}

:deep(.buttonnew .el-button) {
  font-size: 1rem;
}

.buttonnew {
  // all: initial;
  margin-top: 8px;
  margin-right: 7px;
  font-size: 1rem;
}
</style>
